// extracted by mini-css-extract-plugin
export default {"body":"FileExpire_body__kwGyn"};